import { variables } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const Container = styled.div`
  background-color: #e97200;
  color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px 10px;
  height: 38px;
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 100;
`;

export const Button = styled.span`
  color: ${variables.color.white};
  text-decoration: underline;
  font-weight: 600;
  cursor: pointer;
  padding-left: 0.25rem;
`;
